export default __webpack_public_path__ + "static/48dee2c7690fc374b4237fbf9ed41c8a.png";